module.exports = __webpack_public_path__ + "static/hero_image-5208edb8d2bc663cc6192c1f1668c82a.jpg";